import {Typography} from "@mui/material";

export const CsfInfoContent = (selectorContractGridAPI) => {


    switch(selectorContractGridAPI) {

        case 'Dashboard':
            return {
                title: 'Filtering Criteria',
                content: 'Filtering Criteria are Contract Section Filters that determine which contracts will be included in the Dashboard results.  ' +
                    'Their matching behavior is the same as Contract Data Point Filters. '
            };

        default:
            // case 'Drilldown':
            return {
                title: 'Contract Section Filters',
                content: (
                    <>
                        <Typography paragraph>
                            Contract Section Filters control
                            access to a Contract Section.
                        </Typography>

                        <ul>
                            <li>
                                Each filter has a Data Point.
                            </li>

                            <li>
                                Some filters have a Single Value,
                                some have a range of From and To values,
                                and some have no value.
                            </li>

                            <li>
                                The logic attempts to match
                                the Data Point and any associated values
                                to the Contract Data Points
                                on the individual contract model
                                being processed.
                            </li>

                            <li>
                                If there is a match,
                                the system will Allow or Deny access
                                based on the Access Type of the Filter.
                            </li>

                            <li>
                                Any matching Deny filter
                                will deny access.
                            </li>

                            <li>
                                Any matching Allow filter,
                                when there is no matching Deny filter,
                                will allow access.
                            </li>

                            <li>
                                If there are only Deny filters
                                and none match,
                                access is allowed.
                            </li>

                            <li>
                                Contract Section Filters
                                can be nested and branched
                                to create complex filter structures.
                            </li>

                            <li>
                                A filter path only matches
                                if all nested filters
                                in that Path match.
                            </li>

                            <li>
                                All filters in a Path
                                must have the same Access Type
                                of either Allow or Deny.
                            </li>
                        </ul>
                    </>
                )
            }
            //     content: 'Contract Section Filters control access to a Contract Section.  ' +
            //         'Each filter has a Data Point.  Some have a Single Value, some have a range of From and To values.  Some have no value.' +
            //         '  The logic tries to match the Data Point (and values if present) to the Contract Data Points on the individual contract model ' +
            //         'being processed.  If there is a match, the system will Allow or Deny access based on the Access Type of the Filter.  ' +
            //         'Any matching Deny filter will deny access.  Any matching Allow filter (with no matching Deny) will allow access.  ' +
            //         'If there are only Deny filters, and none match, access is allowed.  ' +
            //         'Contract Section Filters can be nested and branched to create complex filters, which only match if all of the nested filters ' +
            //         'in a Path match.  All filters in a Path must have the same Access Type (Allow or Deny).  '
            // };

    }

};